<template>
  <div class="indexPage">
    <div class="list">
      <div class="item" v-if="dataItem != ''">
        <div class="block_one">
          <div class="column flex-rowl">
            <p class="label">创建时间：</p>
            <p class="con">{{ dataItem.order_time }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">订单状态：</p>
            <p class="con">
              {{
                dataItem.service_order_status == 1
                  ? "待接单"
                  : dataItem.service_order_status == 2
                  ? "已接单"
                  : dataItem.service_order_status == 3
                  ? "取餐中"
                  : dataItem.service_order_status == 4
                  ? "送餐中"
                  : dataItem.service_order_status == 5
                  ? "待自提"
                  : dataItem.service_order_status == 6
                  ? "已送达"
                  : "已完成"
              }}
            </p>
          </div>
          <div class="column flex-rowl">
            <p class="label">订单情况：</p>
            <p class="con">
              {{
                dataItem.service_order_property == 1
                  ? "服务订单进行中"
                  : dataItem.service_order_property == 2
                  ? "服务订单取消申请中"
                  : dataItem.service_order_property == 3
                  ? "服务订单已取消"
                  : "服务订单已完成"
              }}
            </p>
          </div>
        </div>

        <div class="block_two">
          <div class="column flex-rowl">
            <p class="label">服务订单号：</p>
            <p class="con">{{ dataItem.service_order_id }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">订单号：</p>
            <p class="con">{{ dataItem.order_id }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">送餐位置：</p>
            <p class="con">{{ dataItem.address_detail }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">关联取餐柜：</p>
            <p class="con">{{ dataItem.service_rating }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">用户姓名：</p>
            <p class="con">{{ dataItem.truename }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">联系电话：</p>
            <p class="con">{{ dataItem.customer_phone }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">订单内容：</p>
            <p class="con">{{ dataItem.order_content }}</p>
          </div>
        </div>

        <div class="block_three">
          <div class="column flex-rowl">
            <p class="label">取餐员：</p>
            <p class="con">{{ pickupInfo.pickup_staff_name }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">取餐员工号：</p>
            <p class="con">{{ pickupInfo.pickup_staff_id }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">联系方式：</p>
            <p class="con">{{ pickupInfo.pickup_staff_contact }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">取餐时间：</p>
            <p class="con">{{ pickupInfo.pickup_time }}</p>
          </div>
        </div>

        <div class="block_three">
          <div class="column flex-rowl">
            <p class="label">送餐员：</p>
            <p class="con">{{ deliveryInfo.delivery_staff_name }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">送餐员工号：</p>
            <p class="con">{{ deliveryInfo.delivery_staff_id }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">联系方式：</p>
            <p class="con">{{ deliveryInfo.delivery_staff_contact }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">送餐时间：</p>
            <p class="con">{{ deliveryInfo.delivery_assignment_time }}</p>
          </div>
        </div>

        <div class="block_three">
          <div class="column flex-rowl">
            <p class="label">分派员：</p>
            <p class="con">{{ serinfoInfo.dispatch_staff_name }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">分派员工号：</p>
            <p class="con">{{ serinfoInfo.dispatch_staff_id }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">联系方式：</p>
            <p class="con">{{ serinfoInfo.dispatch_staff_contact }}</p>
          </div>
          <div class="column dispath_type flex-rowl">
            <p class="label">分派方式：</p>
            <div class="con" v-if="serinfoInfo.dispatch_result">
              <div class="block" v-if="serinfoInfo.dispatch_result == 4">
                <p>直接送达用户</p>
              </div>
              <div class="block" v-else-if="serinfoInfo.dispatch_result == 1">
                <p>已放入取餐柜</p>
                <p>{{ serinfoInfo.locker_number }}</p>
                <p>{{ serinfoInfo.locker_compartment_number }} 格（大件用）</p>
                <p>{{ serinfoInfo.locker_code }}（开柜码）</p>
              </div>
              <div class="block" v-else-if="serinfoInfo.dispatch_result == 2">
                <p>已放入取餐柜</p>
                <p>{{ serinfoInfo.locker_number }}</p>
                <p>{{ serinfoInfo.locker_compartment_number }} 格（小件用）</p>
                <p>{{ serinfoInfo.locker_code }}（开柜码）</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <van-empty
        description="该订单不存在"
        v-if="!isLoading && dataItem == ''"
      />
    </div>

    <div class="custom_btn" @click="handleReturn">返回</div>

    <van-popup v-model="isShow">
      <div class="popup_pic_container">
        <van-image width="300" :src="popupSrc" />
      </div>
    </van-popup>
  </div>
</template>
  
<script>
import { getOrderInfo, getToken } from "../../api/api";
export default {
  name: "orderDetail",
  data() {
    return {
      isShow: false,
      popupSrc: "",
      isLoading: true,
      userInfo: "", // 用户信息
      dataItem: "", // 订单信息
      pickupInfo: "", // 取餐信息
      deliveryInfo: "", // 送餐信息
      order_id: "", // 订单id
      token: "", // token

      returncheck: 1,
    };
  },
  created() {
    let { id } = this.$route.params;
    this.order_id = id;
    this.token = this.$store.state.Authorization;
    this.userInfo = this.$store.state.USERINFO;
    this.getToken();
  },
  methods: {
    // 获取token
    getToken(isSubmit) {
      getToken().then((res) => {
        if (res.error_code == 0) {
          this.$store.commit("changeLogin", res.data.token);

          if (isSubmit) {
            this.scoldCheck(res.data.token);
          } else {
            this.getOrderInfo(res.data.token);
          }
        } else {
          this.$toast.fail(res.message || "接口失效，请稍后～");
        }
      });
    },

    // 查看取餐订单
    getOrderInfo(token) {
      let { order_id } = this;
      const toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      getOrderInfo({ order_id, token }).then((res) => {
        if (res.error_code == 0) {
          if (Object.values(res.data).length != 0) {
            this.dataItem = res.data;
            this.pickupInfo = res.data.pickup;
            this.deliveryInfo = res.data.delivery;
            this.serinfoInfo =
              Object.values(res.data.serinfo).length != 0
                ? res.data.serinfo
                : "";
          } else {
            this.dataItem = "";
          }
          this.isLoading = false;
          toast.clear();
        } else {
          this.$toast.fail(res.message || "接口失效，请稍后～");
          this.isLoading = false;
          toast.clear();
        }
      });
    },
    handleShowPopup(src) {
      this.isShow = true;
      this.popupSrc = src;
    },

    handleReturn() {
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.indexPage {
  padding: 40px 0 300px;
  .list {
    .item {
      width: 660px;
      min-height: 700px;
      background: #ffffff;
      border: 6px solid #e6e6e6;
      border-radius: 40px;
      margin: 0 auto 30px;
      padding: 52px 44px 0;
      box-sizing: border-box;
      font-size: 28px;
      color: #040000;
      .block_one {
        font-size: 30px;
        margin-bottom: 65px;
        .column {
          .label {
            width: 140px;
          }
          .con {
            color: #ff0000;
          }
        }
      }
      .block_two {
        margin-bottom: 99px;
      }
      .block_three {
        margin-bottom: 85px;
      }
      .btn {
        margin-bottom: 60px;
      }
      .column {
        align-items: flex-start;
        &:nth-child(2n) {
          margin: 26px 0;
        }
        .label {
          white-space: nowrap;
          width: 190px;
          flex-shrink: 0;
        }
        .con {
          word-wrap: break-word;
          flex-shrink: 0;
          width: 380px;
        }
      }
    }
  }
  .popup_pic_container {
    // min-height: 40vh;
  }
}
</style>